// Component to Create a new Appointment
import React, { useEffect, useState, useCallback } from "react";
import { format } from "date-fns";
import Axios from "axios";
import LoadingSpin from "../utils/Loading";
import DashboardPatient from "../dashboard/DashboardPatient";
import { useHistory, useLocation } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CancelIcon from "@material-ui/icons/Cancel";
import swal from "sweetalert";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Container,
  Stepper,
  Step,
  StepLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Chip,
  Avatar,
} from "@material-ui/core";
import moment from "moment";
import { dateToString } from "../utils/DateUtils";
import TimeSlots from "./TimeSlots";
import useUserState from "../hooks/useUserState";
import useBDocTranslator from "../hooks/useBDocTranslator";
import { MenuItem } from "@material-ui/core";
import InformationComp from "../utils/InformationComp";
import EventIcon from "@material-ui/icons/Event";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import DescriptionIcon from "@material-ui/icons/Description";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import VideoCallIcon from "@material-ui/icons/VideoCall";
import BusinessIcon from "@material-ui/icons/Business";
import PersonIcon from "@material-ui/icons/Person";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";

function PatientAppointment() {
  const localState = useUserState();
  const [currentUserId, setCurrentUserId] = useState(localState[0].user.id);
  const [patientId, setPatientId] = useState(localState[0].extendedData.id);

  const jwtSession = localState[0].jwt;

  const [service_open, setService_open] = React.useState(false);
  const [service_options, setService_options] = React.useState([]);
  const service_loading = service_open && service_options.length === 0;
  const [service_type_name, setService_type_name] = useState("");

  const [data, setData] = useState("");
  const [duration, setDuration] = useState("");
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const [event_type, setEvent_type] = useState("");
  const [appointment_type, setAppointment_type] = useState("");
  const [appt_date_start, setAppt_date_start] = useState();
  const [appt_date_end, setAppt_date_end] = useState(new Date());
  const [service_type, setService_type] = useState("");
  const [loading_page, setLoading_page] = useState(false);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    error: "",
    visible: false,
    msgClass: "SOMETHING IS WRONG",
  });
  let history = useHistory();
  const location = useLocation();
  const [providerID, setProviderID] = useState(0);
  const [slotsAvailables, setSlotsAvailables] = useState([]);
  const { providerId, locations } = location.state || {};

  const [slotSelected, setSlotSelected] = useState("");
  const [isSameDay, setIsSameDay] = useState(true);
  const [appointmentReason, setAppointmentReason] = useState("");
  const [fileName, setFileName] = useState(null);

  // Stepper state
  const [activeStep, setActiveStep] = useState(0);
  const [selectedServiceIndex, setSelectedServiceIndex] = useState(-1);

  const { t, changeDirectLanguage } = useBDocTranslator();

  const steps = [
    t("Event Type"),
    t("Service Selection"),
    t("Date & Time"),
    t("Details & Confirmation"),
  ];

  React.useEffect(() => {
    // const { providerId } = location.state;
    if (providerId) {
      setProviderID(providerId);
    }
  }, [providerId]);

  /* useEffect(() => {
    if (slotsAvailables.length > 0) {
      fetchTimesAvailables(providerID);
    }
  }, [appt_date_start]); */

  const clearForm = () => {
    document.getElementById("appointment-form").reset();
    setEvent_type("");
    setAppointment_type("");
    setAppt_date_start(moment().format("YYYY-MM-DD"));
    setAppt_date_end("");
    setService_type("");
  };

  const validateFields = () => {
    switch ("") {
      case event_type:
        return "Please Select an Event Type";
      case appointment_type:
        return "Please Select an Appointment Type";
      case service_type:
        return "Please Select a Service Type";
      case appointmentReason:
        return "Please fill out the Reason Field";
      default:
        return false;
    }
  };

  const handleClick = (e) => {
    const emptyFields = validateFields();
    if (emptyFields) {
      swal("Error!", t(emptyFields), "error");
      return false;
    }
    console.log("end date", appt_date_end);
    if (appt_date_end === "Invalid date") {
      swal(
        "Error!",
        t("Please Select hours and minutes for your appointment"),
        "error"
      );
      return false;
    }
    //event_type != "" && Date.parse(appt_date_start + " " + slotSelected) - Date.now() > 0 && appointment_type != "", (typeof slotSelected === String)
    if (
      event_type != null &&
      appointment_type != null &&
      duration != null &&
      slotSelected != null &&
      slotSelected !== "" &&
      appointmentReason != null &&
      appt_date_start != null
    ) {
      setLoading_page(true);
      // create a formdata to send field to save and the file
      const formDataReq = new FormData();
      formDataReq.append("file", fileName);
      formDataReq.append("event_type", event_type);
      formDataReq.append("appointment_type_id", appointment_type);
      formDataReq.append(
        "appt_date_start",
        `${appt_date_start} ${slotSelected}`
      );
      formDataReq.append("appt_date_end", appt_date_end);
      formDataReq.append("appt_status", "NAPPT");
      formDataReq.append("service_type_id", service_type);
      formDataReq.append("appt_reason", appointmentReason);
      formDataReq.append("time_zone", "America.CostaRica");
      formDataReq.append("created_by_user", currentUserId);
      formDataReq.append("patient_id", patientId);
      formDataReq.append("provider_id", providerId);
      formDataReq.append("section_indicator", "PAT");
      formDataReq.append("location_id", eventType === "VIRTUAL" ? 1 : 2);

      Axios.post(
        `${process.env.REACT_APP_API_URL_BASE}/appointments/create`,
        formDataReq,
        {
          headers: { Authorization: "Bearer " + jwtSession },
        }
      )
        .then((response) => {
          setLoading_page(false);
          clearForm();
          swal({
            title: t("Success! Appointment Registered"),
            text: t(response?.data?.message),
            icon: "success",
            button: "OK",
          }).then((ok) => {
            if (ok) {
              history.push({
                pathname: "/patient/appointments",
              });
            }
          });
        })
        .catch((error) => {
          setLoading_page(false);
          swal("Error!", error.response?.data?.message, "error");
        });
    } else {
      swal("Warning!", t("Error, Please fill the Form"), "warning");
    }
  };

  const handleCancel = () => {
    history.goBack();
  };

  const valuetext = (value) => {
    setService_type("CON" + value);
    setDuration(value);
  };

  const handleDateEnd = useCallback((durationMinutes = null) => {
    if (!appt_date_start || !slotSelected) {
      console.log("Missing required data for end date calculation", { appt_date_start, slotSelected });
      return;
    }
    
    const serviceDuration = durationMinutes || duration;
    if (!serviceDuration) {
      console.log("No duration available for end date calculation");
      return;
    }
    
    const startDateTime = `${appt_date_start} ${slotSelected}`;
    const newDate = Date.parse(startDateTime);
    const time = parseInt(serviceDuration) * 60000;
    const end = new Date(newDate + time);
    const newEnd = moment(dateToString(end)).format("yyyy-MM-DD HH:mm:ss");
    console.log("log date", { serviceDuration, time: time, end: end, newEnd: newEnd });
    setAppt_date_end(newEnd);
  }, [appt_date_start, slotSelected, duration]);

  const useStyles = makeStyles((theme) => ({
    root: {
      padding: 0,
      maxWidth: "none",
    },
    container: {
      maxWidth: 900,
      margin: "0 auto",
      padding: theme.spacing(2),
    },
    headerCard: {
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      color: "white",
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(2),
    },
    headerContent: {
      padding: theme.spacing(3),
      textAlign: "center",
    },
    stepperCard: {
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(2),
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    },
    formCard: {
      borderRadius: theme.spacing(2),
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
      marginBottom: theme.spacing(3),
    },
    sectionHeader: {
      padding: theme.spacing(2.5),
      borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
      background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
      borderTopLeftRadius: theme.spacing(2),
      borderTopRightRadius: theme.spacing(2),
    },
    sectionTitle: {
      fontWeight: 600,
      color: "#2c3e50",
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
    },
    sectionContent: {
      padding: theme.spacing(3),
    },
    formControl: {
      marginBottom: theme.spacing(3),
      width: "100%",
    },
    radioGroup: {
      flexDirection: "row",
      gap: theme.spacing(2),
    },
    radioCard: {
      border: "2px solid #e0e0e0",
      borderRadius: theme.spacing(1),
      padding: theme.spacing(1.5),
      transition: "all 0.3s ease",
      cursor: "pointer",
      "&:hover": {
        borderColor: theme.palette.primary.main,
        backgroundColor: "#f5f5f5",
      },
      "&.selected": {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light + "20",
      },
    },
    serviceCard: {
      border: "1px solid #e0e0e0",
      borderRadius: theme.spacing(1),
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      cursor: "pointer",
      transition: "all 0.3s ease",
      "&:hover": {
        borderColor: theme.palette.primary.main,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      },
      "&.selected": {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light + "20",
      },
    },
    serviceInfo: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    priceChip: {
      backgroundColor: "#4caf50",
      color: "white",
      fontWeight: 600,
    },
    dateTimeSection: {
      display: "flex",
      gap: theme.spacing(3),
      alignItems: "flex-start",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        gap: theme.spacing(2),
      },
    },
    dateField: {
      minWidth: 200,
    },
    reasonTextarea: {
      width: "100%",
      minHeight: 120,
      padding: theme.spacing(1.5),
      border: "2px solid #e0e0e0",
      borderRadius: theme.spacing(1),
      fontSize: "1rem",
      fontFamily: theme.typography.fontFamily,
      resize: "vertical",
      transition: "border-color 0.3s ease",
      "&:focus": {
        outline: "none",
        borderColor: theme.palette.primary.main,
      },
    },
    uploadButton: {
      border: "2px dashed #e0e0e0",
      borderRadius: theme.spacing(1),
      padding: theme.spacing(3),
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.3s ease",
      "&:hover": {
        borderColor: theme.palette.primary.main,
        backgroundColor: "#f5f5f5",
      },
    },
    timeSlotsSection: {
      marginTop: theme.spacing(2),
    },
    actionButtons: {
      display: "flex",
      gap: theme.spacing(2),
      justifyContent: "center",
      marginTop: theme.spacing(3),
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "center",
      },
    },
    actionButton: {
      minWidth: 140,
      height: 48,
      fontSize: "1rem",
      fontWeight: 600,
    },
    loadingContainer: {
      display: "flex",
      justifyContent: "center",
      padding: theme.spacing(3),
    },
    infoAlert: {
      marginBottom: theme.spacing(2),
      borderRadius: theme.spacing(1),
    },
  }));

  const classes = useStyles();

  const eventType = [
    { title: t("Virtual Consultation"), value: "VIRTUAL" },
    // { title: t("At Office"), value: "ON-SITE" },
  ];

  //Fecth Services for selected provider
  useEffect(() => {
    const { providerUserId } = location.state || {};
    if (!providerUserId) return;

    async function fetchData() {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL_BASE}/services/findByUserId/public?userId=${providerUserId}`,
          {
            headers: {
              Authorization: "Bearer " + jwtSession,
            },
          }
        );
        const services = await response.json();
        console.log("services", services);
        if (services)
          setService_options(Object.keys(services).map((key) => services[key]));
      } catch (error) {
        console.error("Error fetching services:", error);
        setService_options([]);
      }
    }
    fetchData();
  }, [service_loading, jwtSession]);

  //Fetching times slots availables for the selected provider
  const fetchTimesAvailables = (provider, date) => {
    setLoadingSlots(true);
    const dateISO = new Date(date).toISOString().split(".")[0];
    Axios.get(
      `${
        process.env.REACT_APP_API_URL_BASE
      }/appointments/findHours?providerId=${provider}&date=${dateISO}&locationType=${
        event_type === "VIRTUAL" ? 1 : 2
      }`,
      {
        headers: {
          Authorization: "Bearer " + jwtSession,
        },
      }
    )
      .then((res) => {
        setLoadingSlots(false);

        if (res.data.length < 0) {
          swal(
            "Sorry!",
            t("there are no places available for consultations"),
            "warning"
          );
        }
        setSlotsAvailables(res.data);
      })
      .catch((err) => {
        setLoadingSlots(false);
        setSlotsAvailables([]);
        console.log(err);
        swal("Error!", t("Booking times unavailable"), "error");
      });
  };

  const handleSelection = (e) => {
    e.preventDefault();
    const selectedSlot = e.target.getAttribute("data-slot");
    setSlotSelected(selectedSlot);
    // Recalculate end date with the selected time slot
    if (appt_date_start && selectedSlot && duration) {
      setTimeout(() => handleDateEnd(duration), 0);
    }
  };

  useEffect(() => {
    const isTheSameDay = moment().format("yyyy-MM-DD") === appt_date_start;
    setIsSameDay(isTheSameDay);
    changeDirectLanguage();
  }, [appt_date_start, changeDirectLanguage]);

  // Recalculate end date when any required field changes
  useEffect(() => {
    if (appt_date_start && slotSelected && duration) {
      handleDateEnd(duration);
    }
  }, [appt_date_start, slotSelected, duration]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileName(file);
  };

  // Safe location checks with fallbacks
  const hasNonVirtualLocation =
    locations && locations.length > 0
      ? locations.some((location) => location.name.toUpperCase() !== "VIRTUAL")
      : false;

  const filterLocations =
    locations && locations.length > 0
      ? locations.filter(
          (location) => location.name.toUpperCase() !== "VIRTUAL"
        )
      : [];

  return (
    <DashboardPatient
      sectionTitle={t("Create Appointment")}
      sectionSubtitle="Calendar"
    >
      <Container className={classes.container}>
        {/* Header Card */}
        <Card className={classes.headerCard}>
          <CardContent className={classes.headerContent}>
            <Typography variant="h4" component="h1" gutterBottom>
              <EventIcon style={{ marginRight: 16, verticalAlign: "middle" }} />
              {t("Create Appointment")}
            </Typography>
            <Typography variant="h6" style={{ opacity: 0.9 }}>
              {t(
                "Here you have a complete view of your schedule, your previous and next consultations, can book new appointments and manage a single consultation."
              )}
            </Typography>
          </CardContent>
        </Card>

        {/* Progress Stepper */}
        <Card className={classes.stepperCard}>
          <CardContent>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </CardContent>
        </Card>

        <form id="appointment-form">
          {/* Event Type Selection */}
          <Card className={classes.formCard}>
            <Box className={classes.sectionHeader}>
              <Typography variant="h6" className={classes.sectionTitle}>
                <VideoCallIcon color="primary" />
                {t("Event Type")}
              </Typography>
            </Box>
            <CardContent className={classes.sectionContent}>
              <FormControl className={classes.formControl}>
                <RadioGroup
                  value={event_type}
                  onChange={(e) => setEvent_type(e.target.value)}
                  className={classes.radioGroup}
                >
                  {eventType.map((option) => (
                    <Box
                      key={option.value}
                      className={`${classes.radioCard} ${
                        event_type === option.value ? "selected" : ""
                      }`}
                      onClick={() => setEvent_type(option.value)}
                    >
                      <FormControlLabel
                        value={option.value}
                        control={<Radio color="primary" />}
                        label={
                          <Box display="flex" alignItems="center" gap={1}>
                            {option.value === "VIRTUAL" ? (
                              <VideoCallIcon color="primary" />
                            ) : (
                              <BusinessIcon color="primary" />
                            )}
                            <Typography variant="body1" fontWeight={500}>
                              {option.title}
                            </Typography>
                          </Box>
                        }
                      />
                    </Box>
                  ))}
                </RadioGroup>
              </FormControl>

              {event_type === "ON-SITE" && hasNonVirtualLocation && (
                <Box className={classes.infoAlert}>
                  <InformationComp
                    title={t("Location")}
                    description={`${t(
                      "This provider will see you at the physical location at"
                    )}: ${filterLocations[0]?.name}, ${t("located at")} ${
                      filterLocations[0]?.address
                    }`}
                    severity={"warning"}
                  />
                </Box>
              )}
            </CardContent>
          </Card>

          {/* Appointment Type */}
          <Card className={classes.formCard}>
            <Box className={classes.sectionHeader}>
              <Typography variant="h6" className={classes.sectionTitle}>
                <PersonIcon color="primary" />
                {t("Type of Appointment")}
              </Typography>
            </Box>
            <CardContent className={classes.sectionContent}>
              <FormControl className={classes.formControl}>
                <RadioGroup
                  value={appointment_type}
                  onChange={(e) => setAppointment_type(e.target.value)}
                  className={classes.radioGroup}
                >
                  <Box
                    className={`${classes.radioCard} ${
                      appointment_type === "CONS" ? "selected" : ""
                    }`}
                    onClick={() => setAppointment_type("CONS")}
                  >
                    <FormControlLabel
                      value="CONS"
                      control={<Radio color="primary" />}
                      label={
                        <Typography variant="body1" fontWeight={500}>
                          {t("Consultation")}
                        </Typography>
                      }
                    />
                  </Box>
                  <Box
                    className={`${classes.radioCard} ${
                      appointment_type === "FOLUP" ? "selected" : ""
                    }`}
                    onClick={() => setAppointment_type("FOLUP")}
                  >
                    <FormControlLabel
                      value="FOLUP"
                      control={<Radio color="primary" />}
                      label={
                        <Typography variant="body1" fontWeight={500}>
                          {t("Follow Up")}
                        </Typography>
                      }
                    />
                  </Box>
                </RadioGroup>
              </FormControl>
            </CardContent>
          </Card>

          {/* Service Selection */}
          <Card className={classes.formCard}>
            <Box className={classes.sectionHeader}>
              <Typography variant="h6" className={classes.sectionTitle}>
                <MonetizationOnIcon color="primary" />
                {t("Service")}
              </Typography>
            </Box>
            <CardContent className={classes.sectionContent}>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                {t("Please select the type of service")}
              </Typography>
              {service_options.map((option, index) => (
                <Box
                  key={option.id}
                  className={`${classes.serviceCard} ${
                    selectedServiceIndex === index ? "selected" : ""
                  }`}
                  onClick={() => {
                    setSelectedServiceIndex(index);
                    setService_type_name(option.name);
                    setService_type(option.id);
                    setDuration(option.duration_minute);
                    // Recalculate end date with the new service duration
                    if (appt_date_start && slotSelected) {
                      handleDateEnd(option.duration_minute);
                    }
                  }}
                >
                  <Box className={classes.serviceInfo}>
                    <Box>
                      <Typography variant="h6" gutterBottom>
                        {option.name}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {t("Duration")}: {option.duration_minute} {t("Minutes")}
                      </Typography>
                    </Box>
                    <Chip
                      label={`$${option.price} USD`}
                      className={classes.priceChip}
                    />
                  </Box>
                </Box>
              ))}
            </CardContent>
          </Card>

          {/* Date and Time Selection */}
          <Card className={classes.formCard}>
            <Box className={classes.sectionHeader}>
              <Typography variant="h6" className={classes.sectionTitle}>
                <AccessTimeIcon color="primary" />
                {t("Date & Time")}
              </Typography>
            </Box>
            <CardContent className={classes.sectionContent}>
              <Box className={classes.dateTimeSection}>
                <TextField
                  label={t("Select a date")}
                  type="date"
                  value={appt_date_start}
                  onChange={(event) => {
                    setAppt_date_start(event.target.value);
                    setSlotSelected("");
                    fetchTimesAvailables(providerID, event.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    min: moment().format("YYYY-MM-DD"),
                  }}
                  variant="outlined"
                  className={classes.dateField}
                />
              </Box>

              {/* Time Slots */}
              <Box className={classes.timeSlotsSection}>
                {loadingSlots ? (
                  <Box className={classes.loadingContainer}>
                    <LoadingSpin type="spokes" color="#1d3557" />
                  </Box>
                ) : (
                  <TimeSlots
                    data={slotsAvailables}
                    handleSelection={handleSelection}
                    isSameDay={isSameDay}
                    selectedSlot={slotSelected}
                  />
                )}
              </Box>
            </CardContent>
          </Card>

          {/* Appointment Details */}
          <Card className={classes.formCard}>
            <Box className={classes.sectionHeader}>
              <Typography variant="h6" className={classes.sectionTitle}>
                <DescriptionIcon color="primary" />
                {t("Appointment Details")}
              </Typography>
            </Box>
            <CardContent className={classes.sectionContent}>
              {/* Appointment Reason */}
              <Box marginBottom={3}>
                <Typography variant="subtitle1" gutterBottom fontWeight={600}>
                  {t("Appointment Reason")} *
                </Typography>
                <textarea
                  className={classes.reasonTextarea}
                  onChange={(e) => setAppointmentReason(e.target.value)}
                  placeholder={t("Appointment Reason")}
                  value={appointmentReason}
                  maxLength="200"
                />
                <Typography variant="caption" color="textSecondary">
                  {appointmentReason.length}/200
                </Typography>
              </Box>

              {/* File Upload */}
              <Box>
                <Typography variant="subtitle1" gutterBottom fontWeight={600}>
                  {t("Upload Exam Results or Medical Documents (optional)")}
                </Typography>
                <Box
                  className={classes.uploadButton}
                  onClick={() => document.getElementById("file-input").click()}
                >
                  <input
                    id="file-input"
                    type="file"
                    hidden
                    onChange={handleFileChange}
                  />
                  <AttachFileIcon color="primary" style={{ marginBottom: 8 }} />
                  <Typography variant="body1" color="primary">
                    {fileName
                      ? fileName.name
                      : t(
                          "Upload Exam Results or Medical Documents (optional)"
                        )}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {t("Select Service")}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* Action Buttons */}
          <Box className={classes.actionButtons}>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<CancelIcon />}
              onClick={handleCancel}
              className={classes.actionButton}
            >
              {t("Cancel")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CheckCircleOutlineIcon />}
              onClick={handleClick}
              disabled={loading_page}
              className={classes.actionButton}
            >
              {loading_page ? t("Saving...") : t("Save")}
            </Button>
          </Box>

          {loading_page && (
            <Box className={classes.loadingContainer}>
              <LoadingSpin type="spokes" color="#1d3557" />
            </Box>
          )}
        </form>
      </Container>
    </DashboardPatient>
  );
}

export default PatientAppointment;
